// Mock data for FillTech Technologies landing page

export const companyInfo = {
  name: "FillTech Technologies and Solutions",
  tagline: "Your Trusted Partner for Genuine Printer Consumables & Printer Spares",
  description: "Supplying premium printer consumables, toner cartridges, printer accessories, and OEM genuine products at competitive wholesale prices across Kerala.",
  phone: [
    "9387294448",
    "9072337565",
    "9072327565",
    "9388521456"
  ],
  email: "filltechsolutions@gmail.com",
  address: "CP Complex, Thrissur Road, Bus Stop, Edappal, Malappuram District, Kerala – 679576",
  whatsapp: "9387294448"
};

export const products = [
  {
    id: 1,
    title: "Original OEM Inks",
    description: "Genuine OEM ink from Epson, Canon, HP, and Brother for superior print quality.",
    image: "https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/f5ru90zt_Oem%20Ink.png"
  },
  {
    id: 2,
    title: "Genuine OEM Toner Cartridges",
    description: "High-quality toner cartridges for laser printers with consistent performance and reliability.",
    image: "/toner_combined.jpg"
  },
  {
    id: 3,
    title: "Compatible Toner Cartridges",
    description: "Cost-effective compatible cartridges that meet OEM specifications without compromising quality and pages count.",
    image: "https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/nbzu7ism_Compatible%20toner%20cartridges.jpeg"
  },
  {
    id: 4,
    title: "Toner Powders",
    description: "Premium-quality toner powder refilling with dark blacks, sharp text, and smooth print flow with excellent long lasting print output.",
    image: "https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/vpt9y6x0_Toner%20Powder.jpeg",
    imageFit: "contain"
  },
  {
    id: 5,
    title: "Toner Cartridge & Printer Spares",
    description: "Genuine replacement parts and spares for toner cartridges and printers from all major brands.",
    image: "https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/ugk97ql7_toner%20spares.jpeg",
    imageFit: "contain"
  },
  {
    id: 6,
    title: "Thermal Printers & POS Consumables",
    description: "Thermal Printers, Barcode Labels, Ribbons, and POS consumables for retail and business needs.",
    image: "https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/cfh2ceoq_index.jpg",
    imageFit: "contain"
  },
  {
    id: 7,
    title: "Printer Sales",
    description: "Brand new printers from Epson, Canon, HP, and Brother at competitive wholesale prices.",
    image: "https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/vlpu7cgk_Pinters.png"
  },
  {
    id: 8,
    title: "Printer Support",
    description: "Expert technical support, repairs, and maintenance services for all printer brands.",
    image: "https://customer-assets.emergentagent.com/job_printer-supplies-1/artifacts/gkktmbvh_Printer%20Service.jpeg"
  }
];

export const brands = [
  {
    id: 1,
    name: "Epson",
    image: "https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBwcmludGVyfGVufDB8fHx8MTc3OTcxNTMyOXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Canon",
    image: "https://images.unsplash.com/photo-1650094980833-7373de26feb6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxvZmZpY2UlMjBwcmludGVyfGVufDB8fHx8MTc3OTcxNTMyOXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "HP",
    image: "https://images.unsplash.com/photo-1613395450289-e560907d9308?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxvZmZpY2UlMjBwcmludGVyfGVufDB8fHx8MTc3OTcxNTMyOXww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 4,
    name: "Brother",
    image: "https://images.pexels.com/photos/17235421/pexels-photo-17235421.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  },
  {
    id: 5,
    name: "Image King",
    image: "https://images.pexels.com/photos/8297818/pexels-photo-8297818.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
  }
];

export const features = [
  {
    id: 1,
    title: "Genuine OEM Products",
    description: "100% authentic original equipment manufacturer products ensuring quality and reliability."
  },
  {
    id: 2,
    title: "Wholesale Pricing",
    description: "Competitive wholesale rates that help you maximize profit margins and grow your business."
  },
  {
    id: 3,
    title: "Trusted Distributor",
    description: "Authorized distributor for leading brands with proven track record across Kerala."
  },
  {
    id: 4,
    title: "After-Sales Support",
    description: "Dedicated customer support team providing technical assistance and product guidance."
  },
  {
    id: 5,
    title: "Wide Availability",
    description: "Extensive inventory of consumables and spares for all major printer brands."
  },
  {
    id: 6,
    title: "Fast Assistance",
    description: "Quick response times and efficient order processing for urgent requirements."
  },
  {
    id: 7,
    title: "Bulk Supply",
    description: "Capable of handling large volume orders for dealers and corporate clients."
  },
  {
    id: 8,
    title: "Kerala's Trusted",
    description: "One of the largest showrooms in Central Kerala with satisfied customers statewide."
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Customer Inquiry",
    description: "Contact us via phone, WhatsApp, or email with your requirements."
  },
  {
    id: 2,
    title: "Product Recommendation",
    description: "Our experts suggest the best products based on your needs and budget."
  },
  {
    id: 3,
    title: "Fast Delivery",
    description: "Quick processing and delivery of your order to your location."
  },
  {
    id: 4,
    title: "Ongoing Support",
    description: "Continuous after-sales support and assistance whenever you need it."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    company: "Tech Print Solutions",
    text: "FillTech has been our go-to supplier for over 3 years. Their genuine products and competitive pricing have helped us grow our business significantly.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Menon",
    company: "Office Mart",
    text: "Outstanding service and product quality! Fast delivery and excellent after-sales support. Highly recommended for bulk orders.",
    rating: 5
  },
  {
    id: 3,
    name: "Mohammed Basheer",
    company: "Print Hub",
    text: "The best prices in Kerala for genuine cartridges. Their team is knowledgeable and always ready to help with technical queries.",
    rating: 5
  }
];
